"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Defines the style of the tile summary
 */
var AddinTileSummaryStyle;
(function (AddinTileSummaryStyle) {
    // No style (default)
    AddinTileSummaryStyle[AddinTileSummaryStyle["None"] = 0] = "None";
    // Show a text summary for the tile (the value to show will be the 'summary' property)
    AddinTileSummaryStyle[AddinTileSummaryStyle["Text"] = 1] = "Text";
    // Show a check summary for the tile (the check will show based on the 'checked' property)
    AddinTileSummaryStyle[AddinTileSummaryStyle["Check"] = 2] = "Check";
})(AddinTileSummaryStyle = exports.AddinTileSummaryStyle || (exports.AddinTileSummaryStyle = {}));
//# sourceMappingURL=addin-tile-summary-style.js.map